module.exports = __webpack_public_path__ + "img/clouds-bg-2v.f1bf18d9.png";